module.exports = __webpack_public_path__ + "media/אכל.dfaded3f.mp3";